import { createViewerScript } from './create-viewer-script/createViewerScript';

export const controllersConfig = createViewerScript(
  {},
  {
    useWorkerRaven: true,
  },
);

export const createControllers = controllersConfig.createControllers;
export const initAppForPage = controllersConfig.initAppForPage;
export const exports = controllersConfig.exports;
